export default __webpack_public_path__ + "static/wheel_chair_w.c0b3ff9cb975b0819b9746b74e242366.png";